module.exports = ".confirm-check-wrapper {\n  height: 7.5rem;\n  width: 7.5rem;\n  margin: auto; }\n\n.actions {\n  margin-top: 1.25rem; }\n"